import { Component, Vue } from 'vue-property-decorator';
import { Breadcrumbs } from '../list/types';

@Component
export default class BreadcrumbsMixin extends Vue {
  public breadcrumbs: Breadcrumbs = [
    {
      text: 'Главная',
      to: { path: '/' },
    },
    {
      text: 'Вакансии',
      to: { name: 'vacancies' },
    },
  ];
}



// WEBPACK FOOTER //
// ./src/pages/vacancies/mixins/breadcrumbs-mixin.ts